/* eslint-disable camelcase */
import * as THREE from 'three'
// constants
import { COLORS, SEAT_STATUSES, SEAT_TYPES } from '../constants'
import { getSeatMaterial, getLineMaterial } from '../utils/helper_functions'

export const drawUnclickableTable = ({
  seatId,
  options,
  materials,
  seats,
  seat
}) => {
  const {
    position,
    parent,
    center_x,
    center_y,
    scale,
    sectionLabel,
    rowLabel,
    label,
    opacity = 1,
    sceneMeshes
  } = options

  const {
    type = SEAT_TYPES.CHAIR,
    size,
    table_shape: tableShape = 'circle',
    width,
    height
  } = seat

  position[0] -= center_x * scale
  position[1] += center_y * scale
  let tableObject = null

  switch (tableShape) {
    case 'rect': {
      const rectGeometry = new THREE.PlaneGeometry(
        width * scale,
        height * scale
      )
      const material = new THREE.MeshBasicMaterial({ color: COLORS.DARK_GREY })
      const rect = new THREE.Mesh(rectGeometry, material)
      tableObject = rect
      break
    }
    default: {
      const radius = (size || 14) * scale
      const geometry = new THREE.CircleGeometry(radius, 32)

      tableObject = new THREE.Mesh(
        geometry,
        getSeatMaterial({ color: COLORS.DARK_GREY, opacity }, materials)
      )

      const edges = new THREE.EdgesGeometry(geometry)
      const line = new THREE.LineSegments(
        edges,
        getLineMaterial({ color: COLORS.DARK_GREY, opacity }, materials)
      )
      line.position.set(...position)
      line.renderOrder = -1
      parent.add(line)
    }
  }

  parent.add(tableObject)
  parent.add(tableObject)

  tableObject.renderOrder = -1
  tableObject.position.set(...position)

  tableObject.objectType = 'UNCLICKABLE_TABLE'
  tableObject.opacity = opacity
  tableObject.disabled = true
  tableObject.radius = size
  tableObject.seatId = seatId
  tableObject.status = SEAT_STATUSES.AVAILABLE
  tableObject.sectionLabel = sectionLabel
  tableObject.rowLabel = rowLabel
  tableObject.label = label
  tableObject.seatType = type

  tableObject.changeBorderColor = (color) => {}

  tableObject.mouseOver = null
  tableObject.mouseOut = null
  tableObject.changeBorderColorToDefault = () =>
    tableObject.changeBorderColor(COLORS.DARK_GREY)

  tableObject.changeColor = (color) => {
    tableObject.material = getSeatMaterial(
      { color, opacity: tableObject.opacity },
      materials
    )
    tableObject.changeBorderColorToDefault = () =>
      tableObject.changeBorderColor(color)
  }

  tableObject.updateOpacity = () => {
    tableObject.changeColor(`#${tableObject.material.color.getHexString()}`)
  }

  tableObject.makeDisabled = () => {
    if (tableObject.disabled) {
      return
    }
    tableObject.disabled = true
    tableObject.mouseOver = null
    tableObject.mouseOut = null
    tableObject.opacity = 0.3
  }

  tableObject.makeActive = () => {
    if (!tableObject.disabled) {
      return
    }
    tableObject.disabled = false
    tableObject.mouseOver = null
    tableObject.mouseOut = null
    tableObject.opacity = 1
  }

  tableObject.statusUpdate = (status) => {}
  tableObject.hasHandlers = true
  sceneMeshes.push(tableObject)
  seats[seatId] = tableObject
}
